import ImageCapture from './capture/ImageCapture'
import VideoCapture from './capture/VideoCapture'

export const CAPTURE_OPTIONS = [
  { label: 'รูปภาพ / Image', value: 'image' },
  { label: 'วีดีโอ / Video', value: 'video' },
]

const Capture = (props) => {
  let { action = {} } = props
  let { captureType } = action

  switch (captureType) {
    case 'image':
      return <ImageCapture {...props} />
    case 'video':
      return <VideoCapture {...props} />
    default:
      return
  }
}

export default Capture
